import { render } from "./AnimalEditModal.vue?vue&type=template&id=5357a89b"
import script from "./AnimalEditModal.vue?vue&type=script&lang=js"
export * from "./AnimalEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__